// src/App.js
import React from 'react';
import Header from './components/Header.js';
import RoutesComponent from './components/routes.tsx';
import './styles/global.css'; // Seu CSS global
import { BrowserRouter } from 'react-router-dom';
import { HashRouter } from 'react-router-dom';
import Footer from './components/footer.js';
import { pdfjs } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
      'pdfjs-dist/build/pdf.worker.min.mjs',
      import.meta.url,
    ).toString();
    
function App() {
  return (
    <>
      {/* <BrowserRouter> */}
      <HashRouter>
        <Header />
        <RoutesComponent />
        <Footer />
      </HashRouter>
      {/* </BrowserRouter> */}
    </>
  );
}

export default App;